import { render, staticRenderFns } from "./helpCenterLayout.vue?vue&type=template&id=26830510"
import script from "./helpCenterLayout.vue?vue&type=script&lang=js"
export * from "./helpCenterLayout.vue?vue&type=script&lang=js"
import style0 from "./helpCenterLayout.vue?vue&type=style&index=0&id=26830510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports